import { render, staticRenderFns } from "./EventsEChart.vue?vue&type=template&id=2088ff98&scoped=true&"
import script from "./EventsEChart.vue?vue&type=script&lang=js&"
export * from "./EventsEChart.vue?vue&type=script&lang=js&"
import style0 from "./EventsEChart.vue?vue&type=style&index=0&id=2088ff98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088ff98",
  null
  
)

export default component.exports